export default __webpack_public_path__ + "static/media/private dining.9973b35f.svg";